import cloneDeep from 'lodash.clonedeep';

import { AppStoreState } from '@core/interfaces/app-store-state';

import { NotaryRequestState } from './notary-request-reducer';

export const notaryRequestSelector = (state: AppStoreState): NotaryRequestState =>
  state && state.notaryRequest && state.notaryRequest.length > 0 ? cloneDeep(state.notaryRequest[0]) : null;
